import { render, staticRenderFns } from "./DeliveryFormDetailsList.vue?vue&type=template&id=4e698437&scoped=true&"
import script from "./DeliveryFormDetailsList.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFormDetailsList.vue?vue&type=style&index=0&id=4e698437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e698437",
  null
  
)

export default component.exports